import React, { Suspense } from 'react'
import PropTypes from 'prop-types'

import { useTransitionService } from '@/services/TransitionService'
import { ResizeService } from '@/services/ResizeService'
import { PageVisibilityService } from '@/services/PageVisibilityService'
import { MusicService } from '@/services/MusicService'
import { Metadata } from '@/components/Metadata'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { Menu } from '@/components/Menu'
import { Intro } from '@/components/Intro'
import { Background } from '@/components/Background'

import '@/styles/main.scss'
import * as styles from './Layout.styles.scss'

const IS_BROWSER = typeof window !== 'undefined'

const Layout = ({ site, page, children }) => {
  useTransitionService()

  return (
    <div>
      <Metadata
        title={page.title}
        defaultTitle={
          site.metadata.subtitle
            ? `${site.metadata.title}: ${site.metadata.subtitle}`
            : site.metadata.title
        }
        titleTemplate={`%s — ${site.metadata.title}`}
        favicon={site.favicon}
        description={site.metadata.description}
        image={page.image || site.metadata.image}
        siteUrl={site.metadata.siteUrl}
        path={page.path}
      />
      {IS_BROWSER && (
        <Suspense fallback={<div data-background-loading />}>
          <Background {...site.background} />
        </Suspense>
      )}
      <MusicService {...site.music} />
      <PageVisibilityService>
        <ResizeService>
          <div className={styles.Layout}>
            <Intro {...site.intro} />
            <Header {...site.header} />
            <Menu {...site.menu} />
            <main className={styles.main}>{children}</main>
            <Footer />
          </div>
        </ResizeService>
      </PageVisibilityService>
    </div>
  )
}

Layout.defaultProps = {
  site: {},
  page: {},
}

Layout.propTypes = {
  site: PropTypes.object,
  page: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default Layout
